import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.less'

interface KerberusWidgetProps {
  progress: number
}

export const KerberusWidget: React.FC<KerberusWidgetProps> = ({ progress }) => {
  const { t } = useTranslation()
  return (
    <div className="KerberusWidget">
      {/*<p>Un instant, juste une vérification CAPTCHA...</p>*/}
      <p>{t('kerberusWidget.captchaCheck')}</p>
      <div className="KerberusWidget__progress" style={{ width: `${progress}%` }}></div>
    </div>
  )
}
